import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** True if the URL is any kind of YouTube link. */
export function isYouTubeUrl(url: string): boolean {
  return url.includes("youtube.com") || url.includes("youtu.be");
}

/**
 * Build an embeddable, autoplaying YouTube URL from any YouTube link shape:
 * watch?v=ID, youtu.be/ID, youtube.com/live/ID, /shorts/ID, /embed/ID.
 * Returns null if no 11-char video id can be extracted.
 */
export function getYouTubeEmbedUrl(url: string): string | null {
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|live\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/,
  );
  if (!match) return null;
  return `https://www.youtube.com/embed/${match[1]}?autoplay=1`;
}
